import React from "react";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";

import colorPalette from "../Assets/color-palette-dynamic-color.webp";
import targetISO from "../Assets/bg/target-iso-color.webp";

function About() {
  return (
    <>
      <Navbar />
      <div className="p-3 bg-light-custom" id="aboutMe">
        <div className="container">
          <div className="row">
            <h1 className="fs-bold mt-4 text-purple">About me</h1>
            <div className="col">
              <p>
               I'm a frontend-focused engineer with experience in React, building responsive UI, and currently solving real-world frontend and AI-driven workflow issues in platforms like ServiceNow (Now Assist, Virtual Agent).
              </p>

              <p>
                You can find my work experience on
                <a
                  href="https://in.linkedin.com/in/g-rohit"
                  target="_blank"
                  rel="noopener noreferrer"
                  name="linkedin link"
                  aria-label="linkedin"
                  className="external-link"
                >
                  Linkedin
                </a>
                , and fun projects on
                <a
                  href="https://codepen.io/grohit/"
                  target="_blank"
                  name="codepen link"
                  rel="noopener noreferrer"
                  aria-label="CodePen"
                  className="external-link"
                >
                  Codepen
                </a>
                . I <em>occasionally</em> post my designs on
                <a
                  href="https://www.behance.net/g-rohit"
                  target="_blank"
                  rel="noopener noreferrer"
                  name="Behance link"
                  aria-label="behance"
                  className="external-link"
                  title="I mean I rarely post my designs here :("
                >
                  Behance
                </a>
                . Find my repos on
                <a
                  href="https://github.com/g-rohit"
                  target="_blank"
                  rel="noopener noreferrer"
                  name="github link"
                  aria-label="github"
                  className="external-link"
                >
                  Github
                </a>
                and stay connected on
                <a
                  href="https://instagram.com/developerGrohit"
                  target="_blank"
                  rel="noopener noreferrer"
                  name="Instagram link"
                  aria-label="Instagram"
                  className="external-link"
                >
                  Instagram
                </a>
                . If you would like to work with me,
                <a href="mailto:social@grohit.com" className="external-link">
                  drop me an email
                </a>
                .
              </p>
            </div>
          </div>
          <h3 className="mt-5 mb-4 fs-bold text-dark-purple cursive-underline">
            Skill Sets
          </h3>
          <div className="row mt-3 align-items-lg-start" id="skillSet">
            <div className="col-lg-2 col-md-6 order-2 order-md-1">
              <h4 style={{ color: "#E84274" }}>Design</h4>
              <p>Responsive Design, UI/UX Design, Wireframing, Prototyping</p>
            </div>
            <div className="col-lg-4 col-md-6 order-3 order-md-2 ">
              <h4 style={{ color: "#E08A1C" }}>Development</h4>
              <p>
                <strong>Frontend:</strong> React, Next.js, JavaScript (ES6+),
                TypeScript, HTML5, CSS3, Tailwind, Sass
                <br />
                <strong>Familiar with:</strong> Node.js, Express, MongoDB
              </p>
            </div>
            <div className="col-lg-3 col-md-6 order-4 order-md-3 ">
              <h4 style={{ color: "#945F43" }}>Tools I use</h4>
              <p>Figma, Adobe XD, VS Code, Git, GitHub, Postman, Windsurf, Claude</p>
            </div>
            <div className="col-lg-3 col-md-6 order-sm-1 order-1 order-md-4 ">
              <img
                src={colorPalette}
                alt="colorPalette"
                className="img-fluid moving-image"
                loading="lazy"
              />
            </div>
          </div>
          <div className="row mt-3 align-items-lg-start">
            <div className="col-md-12">
              <h4 style={{ color: "#006aff" }}>AI & Automation</h4>
              <p>Prompt Engineering, Generative AI (Now Assist, Virtual Agent), Conversational UI, Chatbot Workflows, Workflow Automation</p>
            </div>
             
          </div>

          {/* Certificates */}
          <h3 className="my-3 fs-bold text-dark-purple cursive-underline">
            Certificates:
          </h3>

          <div className="row mt-5 align-items-center">
            <div className="col-md-3 mb-4">
              <img
                src={targetISO}
                alt="Target graphic"
                className="img-fluid moving-image shad"
                style={{ maxWidth: "300px" }}
                loading="lazy"
              />
            </div>
            <div className="col-md-9">
              <p>
I invest in continuous learning through certifications and structured courses. Here are credentials that reflect my frontend and platform expertise.
              </p>
            </div>
          </div>

          <div className="row my-5" id="certificates-table">
            <div className="col-md-12 table-responsive rounded rounded-3 shadow-lg p-3">
              <table className="table  col-md-12 table-bordered mb-0">
                <thead className="thead">
                  <tr>
                    <th className="p-3 text-white">Certificate Name</th>
                    <th className="p-3  text-white">Issued by</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td scope="row">
                      <a
                        href="https://www.freecodecamp.org/certification/grohit/responsive-web-design"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Responsive Web Design&nbsp;
                        <i className="fad fa-external-link-alt" />
                      </a>
                    </td>
                    <td>
                      <a
                        href="https://www.freecodecamp.org"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        FreeCodeCamp.org
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td scope="row">
                      <a
                        href="https://www.freecodecamp.org/certification/grohit/javascript-algorithms-and-data-structures"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        JavaScript Algorithms and Data Structures{" "}
                        <i className="fad fa-external-link-alt" />
                      </a>
                    </td>
                    <td>
                      <a
                        href="https://www.freecodecamp.org"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        FreeCodeCamp.org
                      </a>
                    </td>
                  </tr>
                  {/* Salesforce Certs */}
                  <tr>
                    <td scope="row">
                      <a
                        href="https://www.salesforce.com/trailblazer/grohit"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Marketing Cloud Personalization Accredited Professional{" "}
                        <i className="fad fa-external-link-alt" />
                      </a>
                    </td>
                    <td>
                      <a
                        href="https://trailhead.salesforce.com/en/credentials/marketingcloudemailspecialist"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Salesforce
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td scope="row">
                      <a
                        href="https://www.salesforce.com/trailblazer/grohit"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Salesforce Certified Marketing Cloud Email Specialist{" "}
                        <i className="fad fa-external-link-alt" />
                      </a>
                    </td>
                    <td>
                      <a
                        href="https://trailhead.salesforce.com/en/credentials/marketingcloudemailspecialist"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Salesforce
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td scope="row">
                      <a
                        href="https://www.salesforce.com/trailblazer/grohit"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Salesforce Certified Marketing Cloud Administrator{" "}
                        <i className="fad fa-external-link-alt" />
                      </a>
                    </td>
                    <td>
                      <a
                        href="https://trailhead.salesforce.com/en/credentials/marketingcloudadministrator"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Salesforce
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td scope="row">
                      <a
                        href="https://www.salesforce.com/trailblazer/grohit"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Salesforce Certified Associate{" "}
                        <i className="fad fa-external-link-alt" />
                      </a>
                    </td>
                    <td>
                      <a
                        href="https://trailhead.salesforce.com/en/credentials/marketingcloudadministrator"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Salesforce
                      </a>
                    </td>
                  </tr>
                  {/* udemy certs */}
                  <tr>
                    <td scope="row">
                      <a
                        href="https://www.udemy.com/certificate/UC-99ZLUWPJ/"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Photoshop Beginners Mastery{" "}
                        <i className="fad fa-external-link-alt" />
                      </a>
                    </td>
                    <td>
                      <a
                        href="https://www.udemy.com/"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Udemy.com
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td scope="row">
                      <a
                        href="https://www.udemy.com/certificate/UC-9HXGTGYT/"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Mastering Selections and Masks in Photoshop{" "}
                        <i className="fad fa-external-link-alt" />
                      </a>
                    </td>
                    <td>
                      <a
                        href="https://www.udemy.com"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Udemy.com
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td scope="row">
                      <a
                        href="https://www.udemy.com/certificate/UC-PKV5TEEA/"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        ServiceNow Administration{" "}
                        <i className="fad fa-external-link-alt" />
                      </a>
                    </td>
                    <td>
                      <a
                        href="https://www.udemy.com"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Udemy.com
                      </a>
                    </td>
                  </tr>
                  {/* oracle cert */}
                  <tr>
                    <td scope="row">
                      <a
                        href="https://www.youracclaim.com/badges/91149b62-f068-4134-8651-ec617d1cd585/"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Oracle Certified Professional, Java SE 6 Programmer{" "}
                        <i className="fad fa-external-link-alt" />
                      </a>
                    </td>
                    <td>
                      <a
                        href="https://www.youracclaim.com/organizations/oracle/badges"
                        target="_blank"
                        className="text-white text-start"
                        rel="noopener noreferrer"
                      >
                        Oracle
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* social media icons and project CTA */}
          <section className="social d-flex align-items-center justify-content-between mt-3 mb-5 flex-column flex-md-row">
            <div className="social-icons mb-4 w-50 w-md-auto  text-center text-md-start">
              <a
                href="https://in.linkedin.com/in/g-rohit"
                target="_blank"
                rel="noopener noreferrer"
                name="linkedin link"
                aria-label="linkedin"
                className="text-white text-start"
              >
                <i className="fab fa-linkedin fa-2x"></i>
              </a>
              <a
                href="https://www.instagram.com/uiux.rohit/"
                target="_blank"
                rel="noopener noreferrer"
                name="Instagram link"
                aria-label="Instagram"
                className="text-white text-start"
              >
                <i className="fab fa-instagram fa-2x"></i>
              </a>
              <a
                href="https://github.com/g-rohit"
                target="_blank"
                rel="noopener noreferrer"
                name="github link"
                aria-label="github"
                className="text-white text-start"
              >
                <i className="fab fa-github fa-2x"></i>
              </a>
              <a
                href="https://www.behance.net/g-rohit"
                target="_blank"
                rel="noopener noreferrer"
                name="Behance link"
                aria-label="behance"
                title="Behance"
                className="text-white text-start"
              >
                <i
                  className="fab fa-behance-square fa-2x"
                  aria-hidden="true"
                ></i>
              </a>
              <a
                href="https://www.freecodecamp.org/grohit"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="freecodecamp"
                id="profile-link"
                className="text-white text-start"
              >
                <i className="fab fa-free-code-camp fa-2x"></i>
              </a>
              <a
                href="https://codepen.io/grohit/"
                target="_blank"
                name="codepen link"
                rel="noopener noreferrer"
                aria-label="CodePen"
                className="text-white text-start"
              >
                <i className="fab fa-codepen fa-2x"></i>
              </a>
              {/* <a href="https://twitter.com/developerRohit" target="_blank" rel="noopener noreferrer" name="Twitter link"
                        aria-label="Twitter" className='btn'> <i className="fab fa-twitter-square fa-2x"></i> </a> */}
            </div>

            <div className="mb-4">
              <Link to="/projects" className="button">
                Check out my projects{" "}
                <i className="far fa-arrow-right" aria-hidden="true"></i>
              </Link>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default About;
